import componentSizes from "../constants/componentSizes";

/**
 * @deprecated use @streeteasy/design-system/constants/componentSizes instead
 * */
export default {
  LG: componentSizes.LG,
  MD: componentSizes.MD,
  SM: componentSizes.SM
};
